import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaEndereco = (): TabelaColuna => ({
  Chave: 'Endereco',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 250 }}>Endereço</div>
})
